import { render, staticRenderFns } from "./ServicesPlaces.vue?vue&type=template&id=e394cf04&scoped=true&"
import script from "./ServicesPlaces.vue?vue&type=script&lang=js&"
export * from "./ServicesPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e394cf04",
  null
  
)

export default component.exports